function unique_array(arr) {
  const cart = [];

  for (let i = 0; i < arr.length; i++) {
      if (typeof arr[i] == "string") {
        const pkValue = parseInt(arr[i]);
        if(pkValue > 0 && cart.indexOf(pkValue) < 0) cart.push(pkValue);
      } else if (typeof arr[i] == "number") {
        const pkValue = arr[i];
        if(pkValue > 0 && cart.indexOf(pkValue) < 0) cart.push(pkValue);
      }
  }
  
  return cart;
}

function stripTag(str) {
  return str.replace(/<[^>]+>/g, '').trim();
}

function setHandphone(handphone) {
  let result;
  if (Array.isArray(handphone)) result = handphone.join("-");
  else result = handphone;
  if (result === "--") result = "";

  return result;
}

async function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

// 숫자를 comma로 구분하는 함수
function number_format(num) {
  // 숫자 및 부호를 포함한 문자열을 허용
  if (typeof num !== 'string') {
    num = String(num);
  }

  // 정규 표현식을 사용하여 숫자를 천 단위로 구분
  return num.replace(/([+-]?\d+)(\d{3})/, "$1,$2").replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}

// 숫자로 변환 컴마두 빼고
function int_format(str) {
  return Number(str.replace(/,/g, ''));
}

// 숫자를 만 단위로 한글로 표시하는 함수
function number_to_korean(num, min=10000, isShort=true) {
  const units = ['', '만', '억', '조', '경'];
  let result = '';
  let unitIndex = 0;

  num = parseInt(num / min) * min;

  while (num > 0) {
    const part = num % 10000;
    if (part > 0) {
      if (isShort && unitIndex === 0 && part < min) {
        // isShort가 true이고 최소 단위 이하의 숫자일 경우 버림
        result = part + result;
      } else {
        if (part % 1000 === 0) {
          result = (part / 1000) + '천' + units[unitIndex] + ' ' + result;
        } else {
          result = part + units[unitIndex] + ' ' + result;
        }
      }
    }
    num = Math.floor(num / 10000);
    unitIndex++;
  }

  return result.trim();
}

function isRegistNum(jumin) {
  if (typeof jumin !== 'string' || jumin.length !== 13) {
    return false;
  }

  const weights = [2, 3, 4, 5, 6, 7, 8, 9, 2, 3, 4, 5];
  let sum = 0;
  for (let i = 0; i < 12; i++) {
    sum += parseInt(jumin[i]) * weights[i];
  }

  let remainder = (11 - (sum % 11)) % 10;
  return remainder === parseInt(jumin[12]);
}

// 날짜 형식 변환 함수
const formatBirth = (value) => {
  // 숫자만 추출
  const numbers = value.replace(/\D/g, '');
  //console.log('Extracted numbers for birth:', numbers);

  // 8자리 숫자인 경우만 변환
  if (numbers.length === 8) {
    const year = numbers.substring(0, 4);
    const month = numbers.substring(4, 6);
    const day = numbers.substring(6, 8);
    //console.log(`Parsed birth date - Year: ${year}, Month: ${month}, Day: ${day}`);
    
    // 유효한 날짜인지 확인
    const date = new Date(year, month - 1, day);
    //console.log('Constructed date object for birth:', date);
    if (date.getFullYear() === year && 
        date.getMonth() === month - 1 && 
        date.getDate() === day) {
      return `${year}-${month}-${day}`;
    }
  }
  
  return value; // 변환할 수 없으면 원본 반환
};

// 핸드폰 형식 변환 함수
const formatHandphone = (value) => {
  // 숫자만 추출
  const numbers = value.replace(/\D/g, '');

  // 10자리 또는 11자리 숫자인 경우만 변환
  if (numbers.length === 10 || numbers.length === 11) {
    return numbers.replace(/(\d{3})(\d{3,4})(\d{4})/, '$1-$2-$3');
  }

  return value; // 변환할 수 없으면 원본 반환
};

module.exports = {
  unique_array,
  stripTag,
  setHandphone,
  sleep,
  number_format,
  int_format,
  number_to_korean,
  isRegistNum,
  formatBirth,
  formatHandphone,
};
